import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getProposals } from '../../../user/actions/city/GetProposals'
import moment from 'moment-timezone'
import { Link } from 'react-router'
import {
  Container,
  Segment,
  Header,
  Button,
  Message,
  Grid,
  Card,
  Progress,
  List,
  Icon,
  Pagination
} from 'semantic-ui-react'


class DefaultCity extends Component {

    constructor(props) {
        super(props)

    }

    handlePaginationChange(event, { activePage }) {
			
        let { dispatch, proposalsNum } = this.props
        
        dispatch(getProposals(proposalsNum, activePage.toString()))	
    }

    unixTime(unixtime) {

        return moment
			.unix(unixtime)
			.tz(moment.tz.guess())
			.format('DD/MM/YYYY HH:mm')
    }

    render() {

        let { balanceIn, citizenName, citizensNum, budget, proposalsNum, activePage, proposals} = this.props

        const Proposals = ({proposals}) => (
            <Card.Group>
                {proposals.map(proposal => (
                    <Card key={proposal.proposalId} fluid color={proposal.isExecuted ? 'green' : proposal.isDeadlineOver ? proposal.voteYes<=proposal.voteNo ? 'red' : proposal.allVotes<proposal.minimumVotes ? 'red' : 'yellow' : 'yellow'} as={Link} to={'/proposal/'+proposal.proposalId}>
                        <Card.Content textAlign='left'>
                            <Header as='h3' style={{fontWeight: 'normal'}}>
                                {proposal.proposalId}. {proposal.description} {proposal.recipient === 'No recipient' ? '' : 'Recipient: '+proposal.recipient} 
                            </Header>
                            <div>
                                <Progress value={proposal.voteYes} total={proposal.allVotes} color='green' progress='ratio' disabled={proposal.isDeadlineOver} active={!proposal.isDeadlineOver}/>
                                <Progress value={proposal.voteNo} total={proposal.allVotes} color='red' progress='ratio' disabled={proposal.isDeadlineOver} active={!proposal.isDeadlineOver}/>
                            </div>
                            <List horizontal style={{fontWeight: 'normal', color: 'rgba(0,0,0,.68)'}}>
                                {proposal.recipient === 'No recipient' ? '' : <List.Item icon='payment' content={proposal.amount} />}
                                <List.Item icon='users' content={'Min '+proposal.minimumVotes+' voters'} />
                                <List.Item icon='time' content={'Until '+this.unixTime(proposal.deadline)} />
                            </List>
                        </Card.Content>
                    </Card>
				))}
            </Card.Group>
		); 

        const CityInfo = () => (
            <Card fluid>
                <Card.Content>
                    <Card.Header>
						Citizens
                    </Card.Header>
                    <Card.Description>
                        {citizensNum}{' '}
                        (<Link to='/citizens'>
                            Show All
                        </Link>)
                    </Card.Description>	  
                </Card.Content>
                <Card.Content>
                    <Card.Header>
						Budget
                    </Card.Header>
                    <Card.Description>
                        {budget}
                    </Card.Description>	  
                </Card.Content>
                <Card.Content>
                    <Card.Header>
						Proposals
                    </Card.Header>
                    <Card.Description>
                        {proposalsNum}
                    </Card.Description>	  
                </Card.Content>
            </Card>
		);

        const CitizenInfo = () => (
            <Grid.Column width={3}>				  
                <Button.Group size='large' fluid>
                    <Button color='teal' icon as={Link} to='/pay-tax'><Icon name='payment' /> Pay Tax</Button>
                </Button.Group>
                <Card fluid>
                    <Card.Content>
                        <Card.Header>
							Your Taxes
                        </Card.Header>
                        <Card.Description>
                            {balanceIn}
                        </Card.Description>	  
                    </Card.Content>
                </Card>
                <Button.Group size='large' fluid>
                    <Button color='brown' icon as={Link} to='/edit-name'><Icon name='edit' /> Name</Button>
                </Button.Group>
            </Grid.Column>
		);

        return(
            <div>
                <Segment textAlign='center' style={{ padding: '1em 0em'}} vertical>
                    <Header as='h1' style={{fontSize: '4em',fontWeight: 'normal',marginBottom: '1em',marginTop: '1em'}}>Welcome, {citizenName}
                    </Header>
                    <Container textAlign='left' text>
                        <p>This is Decentralized Autonomous City. To create, execute proposals or voting you should have a <Link to='/token'>token</Link>.</p>
                    </Container>
                </Segment>
                <Segment style={{  minHeight: 700, backgroundColor: '#fafafa', padding: '4em 0em' }} inverted vertical>
                    <Container>
                        <Grid stackable>
                            <Grid.Row textAlign='left' >
                                <Grid.Column width={3}>
                                    <Button.Group size='large' fluid>
                                        <Button primary icon as={Link} to='/new-proposal'><Icon name='add' /> Proposal</Button>
                                    </Button.Group>								
                                    <CityInfo/>								
                                </Grid.Column>
                                <Grid.Column textAlign='center' width={10}>
                                    {proposals.length === 0 ? <Container fluid><Message error content='There are no proposals.'/></Container> : 
                                        <Pagination style={{ marginBottom: '1em' }} pointing firstItem={null} lastItem={null} activePage={activePage} onPageChange={this.handlePaginationChange.bind(this)} totalPages={Math.ceil(proposalsNum / 5)} />	}
                                    <Proposals proposals={proposals} />
                                </Grid.Column>								
                                <CitizenInfo />							
                            </Grid.Row>
                        </Grid>
                    </Container>
                </Segment>
            </div>
        )
    }


}

const mapStateToProps = (state) => {
    return {
        citizenName: state.city.data.citizenName,
        citizensNum: state.city.data.citizensNum,
        budget: state.city.data.budget,
        proposalsNum: state.city.data.proposalsNum,
        balanceIn: state.city.data.balanceIn,
        activePage: state.city.data.activePage,
        proposals: state.city.data.proposals
    }
}

export default connect(mapStateToProps)(DefaultCity)

DefaultCity.propTypes = {
   
    citizenName: PropTypes.string,
    citizensNum: PropTypes.string,
    budget: PropTypes.string,
    proposalsNum: PropTypes.string,
    balanceIn: PropTypes.string,
    activePage: PropTypes.string,
    proposals: PropTypes.array,
    dispatch: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/layouts/city/components/DefaultCity.js